const mediaItems = [
  {
    title: '独家实锤！某顶流爱豆地下恋曝光全过程',
    duration: '08:32',
    views: '256.3万',
    tag: '明星恋情',
    image: 'https://readdy.ai/api/search-image?query=Dramatic%20warm%20toned%20abstract%20composition%2C%20overlapping%20circles%20in%20crimson%20and%20gold%2C%20play%20button%20suggestion%20through%20geometric%20layout%2C%20editorial%20style%2C%20no%20text%20no%20people&width=600&height=400&seq=m01-51-007&orientation=landscape',
  },
  {
    title: '综艺录制意外频出，导演组与嘉宾激烈争执',
    duration: '12:15',
    views: '189.7万',
    tag: '综艺翻车',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20fragmented%20triangles%20in%20warm%20red%20and%20dark%20tones%20representing%20conflict%2C%20video%20frame%20aesthetic%2C%20editorial%20art%2C%20no%20text%20no%20people&width=600&height=400&seq=m02-51-008&orientation=landscape',
  },
  {
    title: '网红直播现场产品测试翻车，场面一度尴尬',
    duration: '05:48',
    views: '312.5万',
    tag: '直播翻车',
    image: 'https://readdy.ai/api/search-image?query=Warm%20amber%20abstract%20burst%20effect%2C%20radiating%20geometric%20lines%20like%20social%20media%20trending%2C%20dramatic%20composition%2C%20no%20text%20no%20people%2C%20editorial%20look&width=600&height=400&seq=m03-51-009&orientation=landscape',
  },
  {
    title: '深度揭秘娱乐圈选角潜规则内部操作流程',
    duration: '15:20',
    views: '178.2万',
    tag: '深度追踪',
    image: 'https://readdy.ai/api/search-image?query=Dark%20layered%20abstract%20shapes%20with%20crimson%20highlights%2C%20mysterious%20editorial%20composition%2C%20cinematic%20noir%20vibe%2C%20no%20text%20no%20people&width=600&height=400&seq=m04-51-010&orientation=landscape',
  },
  {
    title: '知名品牌代言人突然解约，背后原因成谜',
    duration: '06:55',
    views: '234.1万',
    tag: '商业内幕',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20split%20composition%20in%20warm%20red%20and%20dark%20gray%2C%20representing%20separation%20and%20mystery%2C%20editorial%20artistic%20style%2C%20no%20text%20no%20people&width=600&height=400&seq=m05-51-011&orientation=landscape',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center gap-3 mb-8 md:mb-10">
          <div className="w-1 h-6 md:h-7 rounded-full bg-primary-500"></div>
          <h2 className="text-xl md:text-2xl font-heading text-foreground-950">视频爆料</h2>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4 md:gap-5">
          {mediaItems.map((item) => (
            <div
              key={item.title}
              className="group cursor-pointer"
            >
              <div className="relative w-full aspect-[3/4] rounded-xl overflow-hidden bg-background-100 mb-3">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent"></div>
                <div className="absolute bottom-3 right-3 px-2 py-0.5 rounded bg-black/70 text-white text-xs font-medium whitespace-nowrap">
                  {item.duration}
                </div>
                <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-10 h-10 md:w-12 md:h-12 rounded-full bg-primary-500/90 flex items-center justify-center group-hover:bg-primary-500 transition-colors">
                  <i className="ri-play-fill text-white text-lg md:text-xl ml-0.5"></i>
                </div>
              </div>
              <h3 className="text-xs md:text-sm font-medium text-foreground-800 leading-snug line-clamp-2 mb-1.5 group-hover:text-primary-500 transition-colors">
                {item.title}
              </h3>
              <div className="flex items-center gap-2 text-xs text-foreground-400">
                <span className="px-1.5 py-0.5 rounded bg-accent-100 text-accent-700 text-xs font-medium whitespace-nowrap">
                  {item.tag}
                </span>
                <span>{item.views} 次播放</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}